<div class="kr-icon-arrow" aria-hidden="true" :class="dynamicClasses" v-html="caret"></div>